module.exports = __webpack_public_path__ + "img/winner_text_en.e321be8e.svg";